import { CardVisual } from 'src/app/pbir/visuals/card/CardVisual.component';
import { ErrorVisual } from 'src/app/pbir/visuals/error/ErrorVisual.component';
import { LineChartVisual } from 'src/app/pbir/visuals/highcharts/LineChartVisual.component';
import { TreemapVisual } from 'src/app/pbir/visuals/highcharts/TreemapVisual.component';
import { WaterfallChartVisual } from 'src/app/pbir/visuals/highcharts/WaterfallChartVisual.component';
import { SortDirection } from 'src/app/services/api.services';
import { VisualChartType } from '../chart-type';
import { VisualChartRoleCategorisation, PbiDataRoles } from '../data-role';
import { SortingGroups } from '../sorting-groups';
import { AreaChartVisual } from 'src/app/pbir/visuals/highcharts/AreaChartVisual.component';

export const OtherChartTypes = {
  unknown: <VisualChartType>{
    name: 'unknown',
    alias: 'unknown',
    dataRoles: {
      rows: null,
      columns: null,
      values: null
    },
    title: 'Unknown',
    icon: 'far fa-question-circle',
    previewImageUrl: '/assets/img/icons/xmark-solid.svg',
    previewWhiteImageUrl: '/assets/img/icons-white/xmark-solid.svg',
    previewRedImageUrl: '/assets/img/icons-red/xmark-solid.svg',
    previewGreyImageUrl: '/assets/img/icons-grey/xmark-solid.svg',

    defaultDataRoles: {
    },

    getDataRoleOptions: (params) => ({
    }),

    roleCategorisation: VisualChartRoleCategorisation.Uncategorised,

    hidden: true,

    visualType: ErrorVisual.type,
    visualTypeOptions: {
      visualOptions: {
        ...ErrorVisual.type.visualOptions,
      },
    },
  },
  
  card: <VisualChartType<CardVisual.Options>>{
    name: 'card',
    alias: 'card',
    dataRoles: {
      rows: null,
      columns: null,
      values: PbiDataRoles.cardFields
    },
    title: 'Card',
    icon: 'far fa-id-card',
    previewImageUrl: '/assets/img/icons/chart-card-solid.svg',
    previewWhiteImageUrl: '/assets/img/icons-white/chart-card-solid.svg',
    previewRedImageUrl: '/assets/img/icons-red/chart-card-solid.svg',
    previewGreyImageUrl: '/assets/img/icons-grey/chart-card-solid.svg',

    defaultDataRoles: {
      measuresDataRole: PbiDataRoles.cardFields.name,
      fallbackDataRole: PbiDataRoles.cardFields.name
    },

    getDataRoleOptions: (params) => ({
      values: {
        maxFields: 1,
        replace: true
      }
    }),

    roleCategorisation: VisualChartRoleCategorisation.Uncategorised,

    visualType: CardVisual.type,
    visualTypeOptions: <CardVisual.Options>{
      ...CardVisual.type.visualOptions,
    },
  },

  lineChart: <VisualChartType<LineChartVisual.Options>>{
    name: 'lineChart',
    alias: 'lineChart',
    dataRoles: {
      rows: PbiDataRoles.chartAxis,
      columns: PbiDataRoles.chartLegend,
      values: PbiDataRoles.chartMeasures
    },
    sortingDataRoles: [PbiDataRoles.chartAxis, PbiDataRoles.chartLegend],
    defaultSortDirection: SortDirection.Ascending,
     
    title: 'Line Chart',
    icon: 'far fa-chart-line',
    previewImageUrl: '/assets/img/icons/chart-line-solid.svg',
    previewWhiteImageUrl: '/assets/img/icons-white/chart-line-solid.svg',
    previewRedImageUrl: '/assets/img/icons-red/chart-line-solid.svg',
    previewGreyImageUrl: '/assets/img/icons-grey/chart-line-solid.svg',

    defaultDataRoles: {
      measuresDataRole: PbiDataRoles.chartLegend.name,
      fallbackDataRole: PbiDataRoles.chartAxis.name
    },

    getDataRoleOptions: (params) => ({
      rows: {
        maxFields: 1,
        replace: true,
      },
      columns: {
        maxFields: 1,
        disabled: (params.values?.fieldCount ?? 0) > 1,
        disabledMessage: 'Cannot add items to Legend, because you have more than one item in Measures.',
        replace: true,
        sortingGroup: 'Legend'
      },
      values: {
        ...(((params.columns?.fieldCount ?? 0) > 0) ? {
          maxFields: 1,
          replace: true
        } : {
          fieldCountForScroll: 12
        }),
      }
    }),

    roleCategorisation: VisualChartRoleCategorisation.Categorised,

    sortingGroups: [
      SortingGroups.chartAxis,
      // SortingGroups.chartLegend
    ],

    visualType: LineChartVisual.type,
    visualTypeOptions: {
      visualOptions: {
        ...LineChartVisual.type.visualOptions,
      },
    },
  },
  
  areaChart: <VisualChartType<AreaChartVisual.Options>>{
    name: 'areaChart',
    alias: 'areaChart',
    dataRoles: {
      rows: PbiDataRoles.chartAxis,
      columns: PbiDataRoles.chartLegend,
      values: PbiDataRoles.chartMeasures
    },
    sortingDataRoles: [PbiDataRoles.chartAxis, PbiDataRoles.chartLegend],
    defaultSortDirection: SortDirection.Ascending,
     
    title: 'Area Chart',
    icon: 'far fa-chart-area',
    previewImageUrl: '/assets/img/icons/chart-area-solid.svg',
    previewWhiteImageUrl: '/assets/img/icons-white/chart-area-solid.svg',
    previewRedImageUrl: '/assets/img/icons-red/chart-area-solid.svg',
    previewGreyImageUrl: '/assets/img/icons-grey/chart-area-solid.svg',

    defaultDataRoles: {
      measuresDataRole: PbiDataRoles.chartLegend.name,
      fallbackDataRole: PbiDataRoles.chartAxis.name
    },

    getDataRoleOptions: (params) => ({
      rows: {
        maxFields: 1,
        replace: true,
      },
      columns: {
        maxFields: 1,
        disabled: (params.values?.fieldCount ?? 0) > 1,
        disabledMessage: 'Cannot add items to Legend, because you have more than one item in Measures.',
        replace: true,
        sortingGroup: 'Legend'
      },
      values: {
        ...(((params.columns?.fieldCount ?? 0) > 0) ? {
          maxFields: 1,
          replace: true
        } : {
          fieldCountForScroll: 12
        }),
      }
    }),

    roleCategorisation: VisualChartRoleCategorisation.Categorised,

    sortingGroups: [
      SortingGroups.chartAxis,
      // SortingGroups.chartLegend
    ],

    visualType: AreaChartVisual.type,
    visualTypeOptions: {
      visualOptions: {
        ...AreaChartVisual.type.visualOptions,
      },
    },
  },
  
  treemap: <VisualChartType<TreemapVisual.Options>>{
    name: 'treemap',
    alias: 'treemap',
    dataRoles: {
      rows: PbiDataRoles.treemapGroup,
      columns: PbiDataRoles.treemapDetails,
      values: PbiDataRoles.treemapMeasures
    },
    sortingDataRoles: [PbiDataRoles.treemapMeasures, PbiDataRoles.treemapGroup],
    defaultSortDirection: SortDirection.Descending,

    title: 'Treemap',
    icon: 'far fa-chart-bar',
    previewImageUrl: '/assets/img/icons/chart-tree-map-solid.svg',
    previewWhiteImageUrl: '/assets/img/icons-white/chart-tree-map-solid.svg',
    previewRedImageUrl: '/assets/img/icons-red/chart-tree-map-solid.svg',
    previewGreyImageUrl: '/assets/img/icons-grey/chart-tree-map-solid.svg',

    defaultDataRoles: {
      measuresDataRole: PbiDataRoles.treemapMeasures.name,
      fallbackDataRole: PbiDataRoles.treemapGroup.name
    },

    getDataRoleOptions: (params) => ({
      rows: {
        maxFields: 1,
        replace: true
      },
      columns: {
        maxFields: 1,
        disabled: (params.values?.fieldCount ?? 0) > 1,
        disabledMessage: 'Cannot add items to Details, because you have more than one item in Measures.',
        replace: true
      },
      values: {
        ...(((params.columns?.fieldCount ?? 0) > 0) ? {
          maxFields: 1,
          replace: true
        } : {
          fieldCountForScroll: 12
        })
      }
    }),

    roleCategorisation: VisualChartRoleCategorisation.Categorised,

    visualType: TreemapVisual.type,
    visualTypeOptions: {
      visualOptions: {
        ...TreemapVisual.type.visualOptions,
      },
    },
  },

  waterfallChart: <VisualChartType<WaterfallChartVisual.Options>>{
    name: 'waterfallChart',
    alias: 'waterfallChart',
    dataRoles: {
      rows: PbiDataRoles.waterfallCategory,
      columns: PbiDataRoles.waterfallBreakdown,
      values: PbiDataRoles.chartMeasures  //checked
    },
    sortingDataRoles: [PbiDataRoles.waterfallCategory],
    defaultSortDirection: SortDirection.Ascending,
     
    title: 'Waterfall Chart',
    icon: 'far fa-chart-bar',
    previewImageUrl: '/assets/img/icons/chart-waterfall-solid.svg',
    previewWhiteImageUrl: '/assets/img/icons-white/chart-waterfall-solid.svg',
    previewRedImageUrl: '/assets/img/icons-red/chart-waterfall-solid.svg',
    previewGreyImageUrl: '/assets/img/icons-grey/chart-waterfall-solid.svg',

    defaultDataRoles: {
      measuresDataRole: PbiDataRoles.chartMeasures.name,
      fallbackDataRole: PbiDataRoles.waterfallCategory.name
    },

    getDataRoleOptions: (params) => ({
      rows: {
        maxFields: 1,
        replace: true,
      },
      columns: {
        maxFields: 1,
        replace: true,
      },
      values: {
        maxFields: 1,
        replace: true,
      }
    }),

    roleCategorisation: VisualChartRoleCategorisation.Categorised,

    sortingGroups: [
      SortingGroups.waterfallValue
    ],

    visualType: WaterfallChartVisual.type,
    visualTypeOptions: {
      visualOptions: {
        ...WaterfallChartVisual.type.visualOptions,
      },
    },
  },
};
